// interfaces
import { $profile } from 'src/api/decoders/profile';
import * as Response from 'src/api/interfaces/responses/blacklist';
import { IBlacklistable } from 'src/interfaces/blacklistable';

export const $blacklistGet = (json: Response.IBlacklistGet): IBlacklistable[] => json.data.map((data) => ({
  id: data.id.toString(),
  profile: $profile(data.blacklistable),
}));
